import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import HandIcon from './hand.svg';
import { Button } from '../../../Button';
import './BottomBarHeader.css';

export const BottomBarHeader = ({ talkToManager, hide }) => (
  <div className="row">
    <div className="col-12 col-md-6">
      <div className="row">
        <div className="col-2 text-center d-flex">
          <img
            alt="Hands"
            className="align-self-center"
            width="50"
            src={HandIcon}
          />
        </div>
        <div className="col-10">
          <h5>Let&apos;s Chat!</h5>
          <p>Need some help or prefer us to complete the rest for you?</p>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-4 text-right d-flex justify-content-center justify-content-md-end my-3 my-md-0">
      <Button
        className="align-self-center t-15 text-uppercase btn-outline-primary px-4 bottom-bar-action"
        title="talk to a manager"
        onClick={() => {
          ReactGA.event({
            category: 'Onboarding',
            action: 'Talk to a Manager',
          });
          talkToManager();
        }}
      />
    </div>
    <div className="col-12 col-md-2 text-right d-flex justify-content-center justify-content-md-end my-3 my-md-0">
      <i className="arrow-down" onClick={hide} />
    </div>
  </div>
);

BottomBarHeader.propTypes = {
  talkToManager: PropTypes.func,
  hide: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/BottomBar/ManagedBottomBar/BottomBarHeader/BottomBarHeader.js